import script from "./SendWhatsapp.vue?vue&type=script&setup=true&lang=js"
export * from "./SendWhatsapp.vue?vue&type=script&setup=true&lang=js"

import "./SendWhatsapp.vue?vue&type=style&index=0&id=fbe8db60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbe8db60"]])

export default __exports__